import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { CarfaxService } from './carfax.service';

angular.module('app-lite.carfax', [])
  .service('carfaxApi', downgradeInjectable(CarfaxService));
